// extracted by mini-css-extract-plugin
export default {"title":"EditListingDestinationsPanel_title__+UNQ7"};